export const allFooterLinks = {
    instagram: "https://www.instagram.com/learntube.ai/?hl=en",
    facebook: "https://www.facebook.com/CareerNinjaIndia/",
    whatsapp: "https://wa.me/919160950649",
    youtube: "https://www.youtube.com/channel/UCxX6KabxbGpk9Be57xMktRQ",
    linkedin: "https://www.linkedin.com/company/careerninja/mycompany/",
    aboutUs: "/contactus",
    termsConditions: "/termsandconditions",
    privacyPolicy: "/privacypolicy",
    refundPolicy: "/refundpolicy",
    getHelpWhatsapp : "https://wa.me/919160950649",
    blogs:'https://learntube.ai/blog/'
}